module.exports = __webpack_public_path__ + "static/media/clustersArc.02081298.svg";